import styled from 'styled-components';

const StyledTextArea = styled.textarea<{
  $resizeArea?: 'block' | 'both' | 'horizontal' | 'inline' | 'none' | 'vertical';
}>`
  && {
    width: 100%;
    border: 1px solid ${({ theme }) => theme.colorSurfaceVariant};
    box-sizing: border-box;
    border-radius: 2px;
    resize: ${({ $resizeArea }) => $resizeArea ?? 'both'};
    font-size: 14px;
    line-height: 20px;
    font-weight: 400;
    display: block;
    background-color: ${({ theme }) => theme.colorSurface};
    border-radius: 4px;
    box-sizing: border-box;
    min-height: 64px;
    min-width: 280px;
    transition:
      box-shadow 0.2s ease 0s,
      border-color 0.2s ease 0s;
    padding: 8px;
    margin: 0px;
    resize: both;
  }

  &&:focus {
    border-color: ${({ theme }) => theme.colorPrimary};
    box-shadow: ${({ theme }) => theme.colorPrimary} 0px 0px 0px 1px inset;
  }
`;

export const TextArea = StyledTextArea;
